import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NavigationStart, RouterEvent, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { PrivacyacceptanceService } from '../../../services/shared/privacyacceptance/privacyacceptance.service';
import { UserService } from '../../../services/core/user/user.service';
import { Subscription } from 'rxjs';
import { ConfigurationSettings } from 'src/app/models/configuration.settings';
import { CommunicationService } from '../../../services/shared/communication/communication.service';

@Component({
  selector: 'app-privacy-statement',
  templateUrl: './privacy-statement.component.html',
  styleUrls: ['./privacy-statement.component.scss']
})
export class PrivacyStatementComponent implements OnInit {
  _routerSubscription: any;
  isReadOnlyModal: boolean;
  subscription: Subscription;
  userRoles = [];

  constructor(private dialogRef: MatDialogRef<PrivacyStatementComponent>,
    private privacyacceptanceService: PrivacyacceptanceService,
    private _userService: UserService,
    private configurationSettings: ConfigurationSettings,
    private communication: CommunicationService,
    @Inject(MAT_DIALOG_DATA) public data: string,
    private router: Router) { }

  ngOnInit() {
    if (sessionStorage.getItem('privacyStatementFlag') && !JSON.parse(sessionStorage.getItem('privacyStatementFlag'))) {
      this._routerSubscription = this.router.events
        .pipe(
          filter((event: RouterEvent) => event instanceof NavigationStart),
          filter(() => !!this.dialogRef)
        )
        .subscribe(() => {
          this.dialogRef.close();
        });
      this.isReadOnlyModal = true;
    } else {
      this.isReadOnlyModal = false;
    }
  }

  onClose() {
    this.dialogRef.close('Close');
  }

  onAccept() {
    this._userService.setUserPrivacyAcceptance()
      .subscribe(
        res => {
          sessionStorage.setItem('privacyStatementFlag', "false");
          this.privacyacceptanceService.sendPrivacyAcceptance(false);
          this.userRoles = sessionStorage.getItem('userRoles') ? sessionStorage.getItem('userRoles').split(',') : [];

          let agent = this.userRoles.find(ob => ob.toLowerCase() === 'agent');
          let seniorAgent = this.userRoles.find(ob => ob.toLowerCase() === 'senioragent' || ob.toLowerCase() === 'senior agent');
          let chatManager = this.userRoles.find(ob => ob.toLowerCase() === 'chatmanager' || ob.toLowerCase() === 'chat manager');

          if ((agent && agent.length > 0) || (seniorAgent && seniorAgent.length > 0) || (chatManager && chatManager.length > 0)) {//if user type is Agent then create hubconnection
            this.configurationSettings.userRole = agent && agent.length > 0 ? 'Agent' : 'Senior Agent';
            if (chatManager && chatManager.length > 0) {
              this.configurationSettings.userRole = 'chatManager';
            }
            if (!localStorage.getItem("agentConnected") || localStorage.getItem("agentConnected") != 'true') {
              this.communication.CreateAgentConnection(localStorage.getItem('userEmailId'));
            }
          }

          this.onClose();
        },
        (error) => {
          this.router.navigate(['signout']);
        }
      )
  }

  //onDecline() {
  //  this._userService.setUserPrivacyAcceptance(false)
  //    .subscribe(
  //      res => {
  //        this.router.navigate(['signout']);
  //      },
  //      (error) => {
  //        this.router.navigate(['signout']);
  //      }
  //    )
  //}
}
